import { useEffect, lazy, Suspense, Fragment } from "react";
import { useSelector } from "react-redux";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import {
  RouteWithHeader,
  PrivateRoute,
} from "./components/common/custom_routes";
import { loadUser } from "./redux/actions/authActions";
import { loading } from "./components/styled/loading";
import { BUYER_ROOT } from "constants/buyer_routes";
import { DASHBOARD, ADD_FARM } from "constants/farmer_routes";
import { ACCOUNT, VERIFY_EMAIL } from "constants/account_routes";
import * as ROUTES from "constants/landing_routes";
import "./style/css/main.min.css";

const Register = lazy(() => import("./pages/common/Register"));
const Login = lazy(() => import("./pages/common/Login"));
const Logout = lazy(() => import("./pages/common/Logout"));
const ForgotPassword = lazy(() => import("./pages/common/ForgotPassword"));
const NotFound = lazy(() => import("./pages/common/NotFound"));
const Landing = lazy(() => import("./pages/landing/Landing"));
const About = lazy(() => import("./pages/landing/About/About"));
const AddFarm = lazy(() => import("./pages/farmer/AddFarm"));
const Index = lazy(() => import("./pages/buyer/Index"));
const Dashboard = lazy(() => import("./pages/farmer/Dashboard"));
const AccountPage = lazy(() => import("./pages/account/AccountPage"));
const VerifyEmail = lazy(() => import("./pages/common/VerifyEmail"));

function App() {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  useEffect(() => {
    isAuthenticated && loadUser();
  }, [isAuthenticated]);
  return (
    <Router>
      <Fragment>
        <ToastContainer {...toastSettings} />
        <Suspense fallback={loading}>
          <Switch>
            <Route exact path={ROUTES.LOGIN_ROUTE} component={Login} />
            <Route exact path={ROUTES.LOGOUT_ROUTE} component={Logout} />
            <Route exact path={ROUTES.REGISTER_ROUTE} component={Register} />
            <Route exact path={VERIFY_EMAIL} component={VerifyEmail} />
            <Route
              exact
              path={ROUTES.FORGOT_PASSWORD_ROUTE}
              component={ForgotPassword}
            />

            <RouteWithHeader
              exact
              path={[ROUTES.ROOT, ROUTES.HOME]}
              component={Landing}
            />
            <RouteWithHeader exact path={ROUTES.ABOUT} component={About} />

            {/* FARMER */}
            <PrivateRoute path={DASHBOARD} component={Dashboard} />
            <PrivateRoute path={ACCOUNT} component={AccountPage} />
            <PrivateRoute path={ADD_FARM} component={AddFarm} />

            {/* USER / BUYER */}
            <PrivateRoute path={BUYER_ROOT} component={Index} />

            <Route component={NotFound} />
          </Switch>
        </Suspense>
      </Fragment>
    </Router>
  );
}
const toastSettings = {
  limit: 3,
  position: "top-center",
  autoClose: 5000,
  hideProgressBar: true,
  newestOnTop: false,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  draggable: false,
  pauseOnHover: true,
};

export default App;
